import type { IValidatedResponse } from '../../httpClient';
import { postRequest } from '../../httpClient';
import type { IRegenerateChallengeComparisonsV1Response } from './regenerate-challenge-comparisons-v1-response';
import { regenerateChallengeComparisonsV1ResponseSchema } from './regenerate-challenge-comparisons-v1-response';

export async function regenerateChallengeComparisonsV1Api(): Promise<
  IValidatedResponse<IRegenerateChallengeComparisonsV1Response>
> {
  return postRequest<IRegenerateChallengeComparisonsV1Response>({
    path: '/sys/challenges/v1/comparisons/regenerate',
    schema: regenerateChallengeComparisonsV1ResponseSchema,
  });
}
